import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { CommonButton } from '@/components/ui/common-button';
import { AlertCircle } from 'lucide-react';

const DeleteTripDialog = ({ open, onOpenChange, trip, onDeleteTrip, isDeleting }) => {
  const [showActiveTripWarning, setShowActiveTripWarning] = useState(false);

  const handleDelete = async () => {
    if (trip?.status === 'ACTIVE' || trip?.status === 'COMPLETED' || trip?.status === 'AUTO_COMPLETE' || trip?.status === 'AUTO_COMPLETED') {
      setShowActiveTripWarning(true);
      return;
    }
    
    await onDeleteTrip(trip);
    onOpenChange(false);
  };

  const closeDialog = () => {
    onOpenChange(false);
    setShowActiveTripWarning(false);
  };

  return (
    <Dialog open={open} onOpenChange={closeDialog}>
      <DialogContent className="sm:max-w-[425px]">
        {showActiveTripWarning ? (
          <>
            <DialogHeader>
              <DialogTitle className="flex items-center gap-2 text-destructive">
                <AlertCircle className="h-5 w-5" />
                Cannot Delete Trip
              </DialogTitle>
              <DialogDescription>
                Trip <span className="font-semibold">{trip?.tripNumber}</span> is currently {trip?.status?.toLowerCase()} and cannot be deleted.
                Only trips with status SCHEDULED, PENDING, or DELAYED can be deleted.
              </DialogDescription>
            </DialogHeader>
            <DialogFooter>
              <CommonButton 
                type="button" 
                variant="default" 
                onClick={closeDialog}
              >
                OK
              </CommonButton>
            </DialogFooter>
          </>
        ) : (
          <>
            <DialogHeader>
              <DialogTitle>Delete Trip</DialogTitle>
              <DialogDescription>
                Are you sure you want to delete trip <span className="font-semibold">{trip?.tripNumber}</span>? 
                This action cannot be undone.
              </DialogDescription>
            </DialogHeader>
            <DialogFooter className="gap-2 sm:gap-0">
              <CommonButton 
                type="button" 
                variant="outline" 
                onClick={closeDialog}
                disabled={isDeleting}
              >
                Cancel
              </CommonButton>
              <CommonButton 
                type="button" 
                variant="destructive" 
                onClick={handleDelete}
                disabled={isDeleting}
              >
                {isDeleting ? 'Deleting Trip...' : 'Delete Trip'}
              </CommonButton>
            </DialogFooter>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default DeleteTripDialog;